import { render, staticRenderFns } from "./config.vue?vue&type=template&id=491744e6&scoped=true"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"
import style0 from "./config.vue?vue&type=style&index=0&id=491744e6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491744e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\kaixinshequ-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('491744e6')) {
      api.createRecord('491744e6', component.options)
    } else {
      api.reload('491744e6', component.options)
    }
    module.hot.accept("./config.vue?vue&type=template&id=491744e6&scoped=true", function () {
      api.rerender('491744e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms/smsConfig/config.vue"
export default component.exports